import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { GENERIC_STATE_STATUS } from "../../../shared/enums";
import { AssessmentMatch } from "../../../model/assessment";

const initialState: {
  data: AssessmentMatch | null;
  userMatches: AssessmentMatch[];
  status: GENERIC_STATE_STATUS;
  error: string;
} = {
  status: GENERIC_STATE_STATUS.FULFILLED,
  data: null,
  error: "",
  userMatches: [],
};
export const assessmentMatchStore = createSlice({
  name: "match",
  initialState,
  reducers: {
    assessmentMatchCreationStart(state) {
      return {
        ...state,
        status: GENERIC_STATE_STATUS.PENDING,
      };
    },
    assessmentMatchCreationSuccess(
      state,
      action: PayloadAction<AssessmentMatch>
    ) {
      const { payload } = action;
      return {
        ...state,
        data: payload,
        status: GENERIC_STATE_STATUS.FULFILLED,
      };
    },
    assessmentMatchCreationFail(state, action: PayloadAction<string>) {
      return {
        ...state,
        status: GENERIC_STATE_STATUS.REJECTED,
        error: action.payload,
      };
    },
  },
});

export const {
  assessmentMatchCreationFail,
  assessmentMatchCreationStart,
  assessmentMatchCreationSuccess,
} = assessmentMatchStore.actions;
